import React, { useState, useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import Margin from '../../../components/shared/margin';
import Head from '../../../components/shared/head';
import {commonStyles as stylesCommon} from '../../../styles/common';
import {useSelector} from 'react-redux';
import LayoutContent from '../../../components/layouts/content2';
import { styles } from './styles';
import {useNavigate, useLocation} from 'react-router-dom';


function Index({setShowSpecials}) {
    const data = useLocation().state;
    const urlSegments = window.location.pathname.split('/');
    const categorie_id = urlSegments[urlSegments.length - 1];

    const navigate = useNavigate();
    const {allmenu} = useSelector((state) => state.initLoad);
    
    const commonStyles  = stylesCommon(); 
    
    const {t, i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menu, setMenu] = useState([]);
    const [titleCategorie, setIitleCategorie] = useState('');

    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'black', zIndex: 999, overflow: 'scroll'}}>
       
            <div style={styles.content}>
                <div style={{...{paddingInline: 20, position: 'relative', marginTop: 10, overflow: 'scroll'}}}>
                        <img width='70%' src={require('./assets/image.png')} />
                        <br/>                        <br/>
                   
                    </div>
                     
            </div>
             <div onClick={()=>setShowSpecials(false)} style={{
                            width: 200,
                            textAlign: 'center',
                            textDecoration: "none",
                            color: 'black',
                            position: 'fixed',
                            bottom: 100,
                            right: 22,
                            zIndex: 100,
                        }}>
                            <div
                                style={
                                    {
                                        borderRadius: 5,
                                        textAlign: 'center',
                                        padding: 2,
                                        backgroundColor: '#ff002c',
                                    }
                                }
                            >
                                <div
                                style={{
                                    padding: 10,
                                    paddingVertical: 15,
                                }}>
                                <p
                                        style={{
                                        fontFamily: "LondrinaSolidRegular",
                                        textAlign: 'center', 
                                        alignSelf: 'center',
                                        fontSize: 23,
                                        textTransform: 'uppercase',
                                            fontWeight: '900',
                                            color : 'white'
                                    
                                        }}>
                                        {langEng ? "Back": "Volver al menú"}
                                
                                </p>
                                </div>
                            </div>
                        </div>
           
            </div>
    );
}

export default Index;